<template>
  <BaseDialog v-if="data"
    :max_width="`600`"
    :dialog="data.dialog"
    :title="data.title"
    v-on:close_dialog="$emit('close_dialog')"
    >
      <p v-html="data.message"></p>
      <p v-if="!!data.description" class="caption">{{data.description}}</p>
      <template v-slot:action>
        <div class="d-flex align-center justify-center my-4">
          <v-btn
              v-for="choice in data.choices" :key="choice.key"
              v-on:click="$emit('confirm_result', choice.key)" text primary>{{choice.val}}</v-btn>
        </div>
      </template>
  </BaseDialog>
</template>

<script>

import BaseDialog from './BaseDialog'

// data: {dialog: false, message: "", choices: [{key, val, mod}]}
export default  {
  components: {BaseDialog},
  props: ["data"],
  data(){
    return {
          dialog: false,
          message: "default message",
          choices: [{key: "ok", val:"ok"}]
    }
  },
  watch: {
    'data.dialog': {
      handler() {
        console.log('DIALOG CHANGED')
      }
    }
  }
}

</script>
